
function withDisplay(Component, SubNav) {
  // eslint-disable-next-line react/display-name
  return (props) => {
    return (
      <div>
        <SubNav/>
        <Component {...props}/>
      </div>
    );
  };
}

export default withDisplay;
